import analytics from 'common/analytics';

import './event-limit-notification.style.sass';
import template from './event-limit-notification.tpl.pug';

class EventLimitNotificationController {
    renew() {
        analytics.trackRenewNotificationRenew();

        return this.onClose();
    }
}

export default {
    selector: 'dbAEventLimitNotification',
    template: template(),
    controller: EventLimitNotificationController,
    bindings: {
        plan: '<',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/event-limit-notification/event-limit-notification.cmpt.js